module.exports = __webpack_public_path__ + "static/media/1024295.21df9629.jpg";